
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radce/najemnik",
      function () {
        return require("private-next-pages/radce/najemnik.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/radce/najemnik"])
      });
    }
  